import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../api.service';
import { environment } from '../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

@Component({
	selector: 'app-file-preview',
	templateUrl: './file-preview.component.html',
	styleUrl: './file-preview.component.css'
})
export class FilePreviewComponent implements OnInit {
	file: any = null;
	fileUrl: any = null;
	File_Storage_URL = environment.File_Storage_URL;
	isImage = false;
	isPdf = false;
	constructor(private sanitizer: DomSanitizer, private toastr: ToastrService, private apiService: ApiService, private activeRoute: ActivatedRoute, private http: HttpClient) { }
	ngOnInit(): void {
		this.activeRoute.queryParams.subscribe(queryParams => {
			this.file = queryParams["file"];
			this.isPdf = this.checkPdf();
			this.isImage = this.checkImage();
			this.fileUrl = this.File_Storage_URL + this.file;
		})
	}

	getFileName() {
		try {
			return this.file.split("/").pop() || "";
		} catch (error) {
			return this.file;
		}
	}

	checkImage() {
		try {
			const ext: string = this.file.split(".").pop() || "";
			const ext_lower = ext.toLowerCase();
			return ext_lower == "png" || ext_lower == "jpg" || ext_lower == "jpeg" || ext_lower == "jfif" || ext_lower == "gif";
		} catch (error) {
			return false;
		}
	}

	checkPdf() {
		try {
			const ext: string = this.file.split(".").pop() || "";
			const ext_lower = ext.toLowerCase();
			return ext_lower == "pdf";
		} catch (error) {
			return false;
		}
	}

	getSafeUrl(url: any) {
		return this.sanitizer.bypassSecurityTrustResourceUrl(url)
	}

	copyLink() {
		let link = this.File_Storage_URL + this.file;
		navigator.clipboard.writeText(link).then(() => { }).catch(err => { });
		this.toastr.success("Link copied to clipboard", 'Copied', {
			timeOut: 3000,
			tapToDismiss: true,
			closeButton: true
		});
	}
}
